module.exports = __webpack_public_path__ + "img/cthd.8177a2e2.png";